import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {LocalStorageService} from './local-storage.service';
import {UserService} from './user/user.service';
import {Language} from '../enums/Language';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  constructor(private translateService: TranslateService,
              private localStorageService: LocalStorageService,
              private userService: UserService) {
  }

  // returns currently selected language
  initiate(): string {
    this.translateService.addLangs(['Hebrew', 'English']);
    this.translateService.setDefaultLang('Hebrew');
    this.translateService.use('Hebrew');

    const selectedLang = this.localStorageService.getLanguage();
    if (selectedLang) {
      this.translateService.use(selectedLang);
      return selectedLang;
    } else {
      return 'Hebrew';
    }
  }

  getLangs(): Array<string> {
    return this.translateService.getLangs();
  }

  switchLanguage(lang: string): void {
    this.translateService.use(lang);
    this.localStorageService.saveLanguage(lang);

    if (!!this.localStorageService.getToken()) {
      this.userService.setUserLanguage(this.getEnumValueByLang(lang)).subscribe();
    }
  }

  switchLanguageByEnum(language: Language): void {
    const lang = this.getLangByEnumValue(language);
    this.switchLanguage(lang);
  }

  isCurrent(lang: string): boolean {
    return lang === this.translateService.currentLang;
  }

  getDir(): string {
    if (this.translateService.currentLang === 'Hebrew') {
      return 'rtl';
    } else {
      return 'ltr';
    }
  }

  getEnumValueByLang(lang: string): Language {
    if (lang === 'Hebrew') {
      return Language.HEB;
    }
    if (lang === 'English') {
      return Language.ENG;
    }
  }

  getLangByEnumValue(language: Language): string {
    if (language === Language.HEB) {
      return 'Hebrew';
    }
    if (language === Language.ENG) {
      return 'English';
    }
  }

  getLangNameToSwitch(forView: boolean): string {
    if (this.translateService.currentLang === 'English') {
      return forView ? 'עברית' : 'Hebrew';
    }
    if (this.translateService.currentLang === 'Hebrew') {
      return 'English';
    }
  }

  getEnumValueByCurrentLang(): Language {
    return this.getEnumValueByLang(this.translateService.currentLang);
  }
}
